const v = {
    borderColor: "#dee2e6",
    borderRadius: "0.25rem",
};

const theme = {
    borderColor: v.borderColor,
    borderRadius: v.borderRadius,
    border: {
        default: `border: 1px solid ${v.borderColor};`,
        rounded: `border: 1px solid ${v.borderColor}; border-radius: ${v.borderRadius};`,
    },

    fontWeightBase: "200",
    fontWeightMedium: "550",
    fontWeightBold: "700",

    colors: {
        white: "#fff",
        secondary: "#6c757d",
        blue: "#3490dc",
        indigo: "#6574cd",
        purple: "#9561e2",
        pink: "#f66d9b",
        red: "#e3342f",
        orange: "#f6993f",
        yellow: "#ffed4a",
        green: "#38c172",
        teal: "#4dc0b5",
        cyan: "#6cb2eb",
        black: "black",
        light: "#f8f9fa",
    },

    shadows: {
        sm: "0 .125rem .25rem rgba(0,0,0,.075) !important",
        md: "0 .5rem 1rem rgba(0,0,0,.15) !important",
        lg: "0 1rem 3rem rgba(0,0,0,.175) !important",
    },

    breakpoints: {
        xs: "575.98px",
        sm: "767.98px",
        md: "991.98px",
        lg: "1199.98px",
    },
};

export default theme;
